/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityPasswordsAggComposition
 */
export interface MonitEntityPasswordsAggComposition {
    /**
     * 
     * @type {number}
     * @memberof MonitEntityPasswordsAggComposition
     */
    letters_only?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityPasswordsAggComposition
     */
    numbers_only?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityPasswordsAggComposition
     */
    letters_numbers?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityPasswordsAggComposition
     */
    all?: number;
}

/**
 * Check if a given object implements the MonitEntityPasswordsAggComposition interface.
 */
export function instanceOfMonitEntityPasswordsAggComposition(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityPasswordsAggCompositionFromJSON(json: any): MonitEntityPasswordsAggComposition {
    return MonitEntityPasswordsAggCompositionFromJSONTyped(json, false);
}

export function MonitEntityPasswordsAggCompositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityPasswordsAggComposition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'letters_only': !exists(json, 'letters_only') ? undefined : json['letters_only'],
        'numbers_only': !exists(json, 'numbers_only') ? undefined : json['numbers_only'],
        'letters_numbers': !exists(json, 'letters_numbers') ? undefined : json['letters_numbers'],
        'all': !exists(json, 'all') ? undefined : json['all'],
    };
}

export function MonitEntityPasswordsAggCompositionToJSON(value?: MonitEntityPasswordsAggComposition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'letters_only': value.letters_only,
        'numbers_only': value.numbers_only,
        'letters_numbers': value.letters_numbers,
        'all': value.all,
    };
}

